import React from 'react';
import Counter from '../ReusableComponents/counter';

//MUI
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { Container } from '@mui/system';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';

//Images
import im16 from '../../assets/images/SDG/16.jpg';
import im17 from '../../assets/images/SDG/17.jpg';
import P1 from '../../assets/images/cardImages/ethics.jpg';
import bg from '../../assets/images/background.svg'
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import GavelRoundedIcon from '@mui/icons-material/GavelRounded';
import WestIcon from '@mui/icons-material/West';
import EastIcon from '@mui/icons-material/East';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

const counterData = [
    {
        "num": 29,
        "label": "Awareness programmes held for Value Chain Partners ",
        "icon": LocalShippingIcon,
        "prefix": "",
        "isdecimal": false,
        "suffix": ""
    },
    {
        "num": 68.9,
        "label": "Value Chain covered under Safety, Health and Environment Awareness Programmes",
        "icon": WorkspacesIcon,
        "prefix": "",
        "isdecimal": true,
        "suffix": "%"
    },
    {
        "num": 100,
        "label": "Workmen Trained on Ethics/ Human Rights topics",
        "icon": GavelRoundedIcon,
        "prefix": "",
        "isdecimal": false,
        "suffix": "%"
    },
]

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const StyledBox = styled(Box)`
  ${({ theme }) => `
  cursor: pointer;
  transition: ${theme.transitions.create(['transform'], {
    duration: theme.transitions.duration.standard,
})};
  &:hover {
    transform: scale(2);
  }
  `}
`;

const Sectionc1 = () => {
    const [expanded1, setExpanded1] = React.useState(false);
    const handleExpandClick1 = () => {
        setExpanded1(!expanded1);
    };

    const [expanded2, setExpanded2] = React.useState(false);
    const handleExpandClick2 = () => {
        setExpanded2(!expanded2);
    };

    const [expanded3, setExpanded3] = React.useState(false);
    const handleExpandClick3 = () => {
        setExpanded3(!expanded3);
    };

    const [expanded4, setExpanded4] = React.useState(false);
    const handleExpandClick4 = () => {
        setExpanded4(!expanded4);
    };

    const [expanded5, setExpanded5] = React.useState(false);
    const handleExpandClick5 = () => {
        setExpanded5(!expanded5);
    };

    const [expanded6, setExpanded6] = React.useState(false);
    const handleExpandClick6 = () => {
        setExpanded6(!expanded6);
    };

    const [expanded7, setExpanded7] = React.useState(false);
    const handleExpandClick7 = () => {
        setExpanded7(!expanded7);
    };

    const [expanded8, setExpanded8] = React.useState(false);
    const handleExpandClick8 = () => {
        setExpanded8(!expanded8);
    };

    const [expanded9, setExpanded9] = React.useState(false);
    const handleExpandClick9 = () => {
        setExpanded9(!expanded9);
    };

    const [expand, setExpand] = React.useState(false);
    const expandAll = () => {
        setExpand(true); setExpanded1(true); setExpanded2(true); setExpanded3(true); setExpanded4(true); setExpanded5(true); setExpanded6(true); setExpanded7(true); setExpanded8(true); setExpanded9(true);
    };
    const closeAll = () => {
        setExpand(false); setExpanded1(false); setExpanded2(false); setExpanded3(false); setExpanded4(false); setExpanded5(false); setExpanded6(false); setExpanded7(false); setExpanded8(false); setExpanded9(false);
    };


    return (
        <Container>
            <Box mt={3} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button startIcon={<WestIcon />} sx={{ fontWeight: 'bold' }} href='/sectionb'>
                    Previous
                </Button>
                <Button endIcon={<EastIcon />} sx={{ fontWeight: 'bold' }} href='/sectionc2'>
                    Next
                </Button>
            </Box>
            <Box mt={3} sx={{
                display: 'flex',
                alignItems: 'center',
                height: { xs: '150px', md: '300px' },
                backgroundImage: `url(${bg})`,
                backgroundSize: 'cover',
                borderRadius: '8px'
            }}>
                <Box px={5} py={3} sx={{ width: '100%' }}>
                    <Typography sx={{ typography: { xs: 'h5', md: 'h4' }, color: "#ffffff" }}>
                        Principle 1
                    </Typography>
                    <Typography mt={2} sx={{ typography: { xs: 'body1', md: 'h6' }, color: "#ffffff" }}>
                        Integrity and Ethics
                    </Typography>
                    <Box mt={2} sx={{ display: { xs: 'none', lg: 'flex' } }}>
                        <Typography variant='body1' sx={{ color: "#ffffff" }}>
                            Businesses should conduct and govern themselves with integrity, and in a manner that is Ethical, Transparent and Accountable
                        </Typography>
                    </Box>
                    <Box mt={3} sx={{ display: { xs: 'none', lg: 'flex' } }}>
                        <StyledBox><img src={im16} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im17} height="40" alt="svg" /></StyledBox>
                    </Box>
                </Box>
                <Box sx={{
                    backgroundImage: `url(${P1})`,
                    backgroundSize: 'cover',
                    borderRadius: '0 8px 8px 0',
                    height: { xs: '150px', md: '300px' },
                    width: '100%'
                }}>
                </Box>
            </Box>
            <Box px={4} py={6} mt={{ xs: 4, md: 8 }} sx={{ backgroundColor: '#e6e7e8', borderRadius: '8px' }}>
                <Box mb={6} display="flex" justifyContent="center">
                    <Typography className='heading' variant='h4' sx={{ color: "#e31837", fontSize: "34px", fontWeight: "900" }}>
                        Highlights
                    </Typography>
                </Box>
                <Box>
                    <Counter data={counterData} />
                </Box>
            </Box>
            <Box mt={5} sx={{ textAlign: "right" }}>
                <button onClick={!expand ? expandAll : closeAll} className="custom-button">
                    <span>
                        {!expand ? 'Expand All' : "Close All"}
                        {!expand ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                    </span>
                </button>
            </Box>
            <Box mt={4}>
                <Typography className='heading' variant='h4' sx={{ fontSize: '28px', color: "#e31837" }}>
                    Essential Indicators
                </Typography>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            1. Percentage covered by training and awareness programmes on any of the principles during the financial year:
                            <ExpandMore
                                expand={expanded1}
                                onClick={handleExpandClick1}
                                aria-expanded={expanded1}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded1} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell><strong>Segment</strong></TableCell>
                                        <TableCell align="center" ><strong>Total number of training and awareness programs held</strong></TableCell>
                                        <TableCell><strong>Topics/ principles covered under the training and its impact</strong></TableCell>
                                        <TableCell align="center" ><strong>% of persons in respective category covered by the awareness programmes</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Board of directors
                                        </TableCell>
                                        <TableCell align='center'>
                                            21
                                        </TableCell>
                                        <TableCell>
                                            Familiarization Programmes which cover Governance and Regulatory Requirements, Risk Management, Industry Outlook, Code of Conduct, Conflict of Interest, Responsibilities and Liabilities of Independent Directors and The Company’s Code of Conduct for Prevention of Insider Trading and Business Responsibility &amp; Sustainability Policy.
                                        </TableCell>
                                        <TableCell align='center'>100</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Key Managerial personnel
                                        </TableCell>
                                        <TableCell align='center'>3</TableCell>
                                        <TableCell>
                                            Code of Conduct, Prevention of Sexual Harassment at Workplace, Whistle Blower Mechanism, Anti-Bribery &amp; Anti-Corruption and Gifts and Entertainment
                                        </TableCell>
                                        <TableCell align='center'>100</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Employees other than BoD and KMPs
                                        </TableCell>
                                        <TableCell align='center'>3*</TableCell>
                                        <TableCell>
                                            Code of Conduct, Prevention of Sexual Harassment at Workplace, Whistle Blower Mechanism, Anti-Bribery &amp; Anti-Corruption and Gifts and Entertainment
                                        </TableCell>
                                        <TableCell align="center">
                                            100
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Workers
                                        </TableCell>
                                        <TableCell align='center'>1</TableCell>
                                        <TableCell>
                                            Code of Conduct (COC), Prevention of Sexual Harassment at Workplace (PoSH), Whistle Blower Mechanism
                                        </TableCell>
                                        <TableCell align="center">100</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Typography mt={2} variant='body2'>*  The above-mentioned data of trainings pertains exclusively to the ethical trainings conducted. Other than the above, trainings on topics such as Human rights, Health &amp; Safety, Skill upgradation, etc are also undertaken by the employees.</Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            2. Details of fines/ penalties/ punishment/ award/ compounding fees/ settlement amount paid in proceedings (by the entity or by directors/ KMPs) with regulators/ law enforcement agencies/ judicial
                            institutions, in the financial year, in the following format.
                            <ExpandMore
                                expand={expanded2}
                                onClick={handleExpandClick2}
                                aria-expanded={expanded2}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded2} timeout="auto" unmountOnExit>
                    <Box mb={2}>
                        <Typography variant='body1'>
                            <strong>(a) Monetary*</strong>
                        </Typography>
                    </Box>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} size="small">
                            <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                    <TableCell><strong>Type</strong></TableCell>
                                    <TableCell align="center" ><strong>NGRBC Principle</strong></TableCell>
                                    <TableCell align="center" ><strong>Name of the regulatory/
                                        enforcement agencies/
                                        judicial institutions
                                    </strong></TableCell>
                                    <TableCell align="center" ><strong>Amount (In INR)
                                    </strong></TableCell>
                                    <TableCell align="center" ><strong>Brief of the Case
                                    </strong></TableCell>
                                    <TableCell align="center" ><strong>Has an appeal been
                                        preferred? (Yes/ No)
                                    </strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">
                                        Penalty/ Fine
                                    </TableCell>
                                    <TableCell align="center">Nil</TableCell>
                                    <TableCell align="center">NA</TableCell>
                                    <TableCell align="center">-</TableCell>
                                    <TableCell align="center">NA</TableCell>
                                    <TableCell align="center">No</TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">
                                        Settlement
                                    </TableCell>
                                    <TableCell align="center">Nil</TableCell>
                                    <TableCell align="center">NA</TableCell>
                                    <TableCell align="center">-</TableCell>
                                    <TableCell align="center">NA</TableCell>
                                    <TableCell align="center">No</TableCell>
                                </TableRow>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">
                                        Compounding fee
                                    </TableCell>
                                    <TableCell align="center">Nil</TableCell>
                                    <TableCell align="center">NA</TableCell>
                                    <TableCell align="center">-</TableCell>
                                    <TableCell align="center">NA</TableCell>
                                    <TableCell align="center">No</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box mb={2} mt={4}>
                        <Typography variant='body1'>
                            <strong>(b) Non-Monetary</strong>
                        </Typography>
                    </Box>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell><strong>Type</strong></TableCell>
                                        <TableCell align="center" ><strong>NGRBC Principle</strong></TableCell>
                                        <TableCell align="center" ><strong>Name of the regulatory/
                                            enforcement agencies/
                                            judicial institutions
                                        </strong></TableCell>

                                        <TableCell align="center"><strong>Brief of the Case
                                        </strong></TableCell>
                                        <TableCell align="center"><strong>Has an appeal been
                                            preferred? (Yes/ No)
                                        </strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Imprisonment
                                        </TableCell>
                                        <TableCell align="center">Nil</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">No</TableCell>

                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Punishment
                                        </TableCell>
                                        <TableCell align="center">Nil</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">No</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Typography mt={2} variant='body2'>* There are no fines / penalties /punishment/ award/ compounding fees/ settlement amount paid in proceedings (by the Company or by directors / KMPs) with regulators/ law enforcement agencies/ judicial institutions in the financial year which are material as specified in Regulation 30(4)((i)(c) of SEBI (Listing Obligations and Disclosure Obligations) Regulations, 2015 (“LODR”). Please refer to Company's website at <a href="https://www.mahindra.com/investor-relations/regulatory-filings" target="_blank" rel="noopener noreferrer">https://www.mahindra.com/investor-relations/regulatory-filings</a> to access the disclosures made to the Stock Exchanges under Regulation 30 of LODR for penalties levied by Tax Authorities in connection with assessment matters.</Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            3. Of the instances disclosed in Question 2 above, details of the Appeal/ Revision preferred in cases where monetary or non-monetary action has been appealed.
                            <ExpandMore
                                expand={expanded3}
                                onClick={handleExpandClick3}
                                aria-expanded={expanded3}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded3} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper} m>
                            <Table sx={{ minWidth: 650 }} size="small">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>Case Details</strong></TableCell>
                                        <TableCell align="center" sx={{ minWidth: 400 }}><strong>Name of the regulatory/ enforcement agencies/ judicial institutions</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center'>
                                            NA
                                        </TableCell>
                                        <TableCell component="th" scope="row" align='center'>
                                            NA
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            4. Does the entity have an anti-corruption/ anti-bribery policy? If yes, provide details in brief and if available, provide a web link to the policy.
                            <ExpandMore
                                expand={expanded4}
                                onClick={handleExpandClick4}
                                aria-expanded={expanded4}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded4} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            Yes, the Company has a policy on Anti-Bribery and Anti-Corruption (ABAC policy). The ABAC policy of Mahindra Group establishes a framework to ensure compliance with global Anti-Bribery and Anti-Corruption laws and other required practices. The Company adopts a strict zero-tolerance stance toward any form of bribery or corrupt practices, prioritizing integrity over business gains. All stakeholders are required to comply with this policy or the relevant local laws—whichever is stricter—and no exceptions or waivers are permitted. The policy outlines responsibilities and provides guidance to help identify and manage bribery and corruption risks in interactions with various stakeholders such as government and private entities etc. It reflects Mahindra’s commitment to acting professionally, fairly, and ethically in all business dealings, and is to be read in conjunction with the Company’s Code of Conduct.
                            <br />The web-link to the policy is <a href='https://www.mahindra.com/investor-relations/policies-and-documents' target="_blank" rel="noopener noreferrer">https://www.mahindra.com/investor-relations/policies-and-documents</a>
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            5. Number of Directors/ KMPs/ employees/ workers against whom disciplinary action was taken by any law enforcement agency for the charges of bribery/ corruption:
                            <ExpandMore
                                expand={expanded5}
                                onClick={handleExpandClick5}
                                aria-expanded={expanded5}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded5} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper} m>
                            <Table sx={{ minWidth: 650 }} size="small">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell ><strong>Category</strong></TableCell>
                                        <TableCell align="center" ><strong>FY25<br></br> (Current Financial Year)</strong></TableCell>
                                        <TableCell align="center" ><strong>FY24
                                            <br></br> (Previous Financial Year)</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Directors
                                        </TableCell>
                                        <TableCell align="center">0</TableCell>
                                        <TableCell align="center">0</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            KMPs
                                        </TableCell>
                                        <TableCell align="center">0</TableCell>
                                        <TableCell align="center">0</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Employees
                                        </TableCell>
                                        <TableCell align="center">0</TableCell>
                                        <TableCell align="center">0</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Workers
                                        </TableCell>
                                        <TableCell align="center">0</TableCell>
                                        <TableCell align="center">0</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            6. Details of complaints with regard to conflict of interest:
                            <ExpandMore
                                expand={expanded6}
                                onClick={handleExpandClick6}
                                aria-expanded={expanded6}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded6} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper} m>
                            <Table sx={{ minWidth: 650 }} size="small">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell rowSpan={2}><strong>Topic</strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>FY25 <br />(Current Financial Year)</strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>FY24 <br />(Previous Financial Year)</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center" ><strong>Number</strong></TableCell>
                                        <TableCell align="center" ><strong>Remarks</strong></TableCell>
                                        <TableCell align="center" ><strong>Number</strong></TableCell>
                                        <TableCell align="center" ><strong>Remarks</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" >
                                            Number of complaints received in relation to issues of Conflict of Interest of the Directors
                                        </TableCell>
                                        <TableCell align="center">0</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">0</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" >
                                            Number of complaints received in relation to issues of Conflict of Interest of the KMPs
                                        </TableCell>
                                        <TableCell align="center">0</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                        <TableCell align="center">0</TableCell>
                                        <TableCell align="center">NA</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            7. Provide details of any corrective action taken or underway on issues related to fines/ penalties/ action taken by regulators/ law enforcement agencies/ judicial institutions, on cases of corruption and
                            conflicts of interest.
                            <ExpandMore
                                expand={expanded7}
                                onClick={handleExpandClick7}
                                aria-expanded={expanded7}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded7} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            NA
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            8. Number of days of accounts payables ((Accounts payable*365) / Cost of goods/services procured) as provided in the format.
                            <ExpandMore
                                expand={expanded5}
                                onClick={handleExpandClick5}
                                aria-expanded={expanded5}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded5} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper} m>
                            <Table sx={{ minWidth: 650 }} size="small">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell><strong>Parameter</strong></TableCell>
                                        <TableCell align="center" ><strong>FY25<br></br> (Current Financial Year)</strong></TableCell>
                                        <TableCell align="center" ><strong>FY24
                                            <br></br> (Previous Financial Year)</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Number of days of
                                            accounts payables
                                        </TableCell>
                                        <TableCell align="center">81</TableCell>
                                        <TableCell align="center">99</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            9. Open-ness of business: Provide details of concentration of purchases and sales with trading houses, dealers, and related parties along-with loans and advances & investments,
                            with related parties in the format provided:
                            <ExpandMore
                                expand={expanded5}
                                onClick={handleExpandClick5}
                                aria-expanded={expanded5}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded5} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper} m>
                            <Table sx={{ minWidth: 650 }} size="small">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center" ><strong>Parameter</strong></TableCell>
                                        <TableCell align="center" ><strong>Metrics</strong></TableCell>
                                        <TableCell align="center" ><strong>FY 2025-26<br></br> (Current Financial Year)</strong></TableCell>
                                        <TableCell align="center" ><strong>FY 2024-25
                                            <br></br> (Previous Financial Year)</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center' rowSpan={3}>
                                            Concentration of Purchases
                                        </TableCell>
                                        <TableCell>a. Purchases from trading houses as % of total purchases</TableCell>
                                        <TableCell align="center">0.07%</TableCell>
                                        <TableCell align="center">0.04%</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>b. Number of trading houses where purchases are made from</TableCell>
                                        <TableCell align="center">20</TableCell>
                                        <TableCell align="center">11</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>c. Purchases from top 10 trading houses as % of total purchases from trading houses. </TableCell>
                                        <TableCell align="center">95.7%</TableCell>
                                        <TableCell align="center">99.5%</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center' rowSpan={3}>
                                            Concentration
                                            of Sales
                                        </TableCell>
                                        <TableCell>a. Sales to dealers/ distributors as a % of total sales.</TableCell>
                                        <TableCell align="center">96.2%</TableCell>
                                        <TableCell align="center">99.1%</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>b. Number of dealers/ distributors to whom sales are made</TableCell>
                                        <TableCell align="center">4,480</TableCell>
                                        <TableCell align="center">3,695</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>c. Sales to top 10 dealers/ distributors as a % of total sales to dealers/ distributors </TableCell>
                                        <TableCell align="center">13.9%</TableCell>
                                        <TableCell align="center">23.11%</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center' rowSpan={4}>
                                            Share of RPTs in
                                        </TableCell>
                                        <TableCell>a. Purchases (Purchases with related parties/ Total purchases)</TableCell>
                                        <TableCell align="center">9.8%</TableCell>
                                        <TableCell align="center">10.5%</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>b. Sales (Sales to related parties/ Total Sales) </TableCell>
                                        <TableCell align="center">13.2%</TableCell>
                                        <TableCell align="center">7.7%</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>c. Loans &amp; Advances (Loans &amp; Advances given to related parties/ Total loans &amp; advances) </TableCell>
                                        <TableCell align="center">108%*</TableCell>
                                        <TableCell align="center">111%</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>d. Investments (Investments in related parties/ Total Investments made)  </TableCell>
                                        <TableCell align="center">16.7%</TableCell>
                                        <TableCell align="center">8.5%</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box mt={1}>
                            <Typography variant='body2'>
                                * The share of RPTs in loans and advances exceeds 100% owing to repayment of certain prior period loans by related parties during the current financial year, thereby causing the financial value to exceed the closing balance of total loans and advances.
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={6}>
                <Typography className='heading' variant='h4' sx={{ fontSize: '28px', color: "#e31837" }}>
                    Leadership Indicators
                </Typography>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            1. Awareness programmes conducted for value chain partners on any of the Principles during the financial year:
                            <ExpandMore
                                expand={expanded8}
                                onClick={handleExpandClick8}
                                aria-expanded={expanded8}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded8} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography mb={2} variant='body1'>The Company implements awareness and capacity-building initiatives across its supplier base such as ESG and Supplier Risk Management &amp; Mitigation (SRMM) Programmes. In addition, the Supplier Business Capability Building (SBCB) programme is targeted at critical, long-term, strategic, and identified high-risk suppliers. Under these programmes, a range of training sessions were conducted during FY 2025-26 covering corporate governance, ethical practices, transparency and accountability, health and safety, employee wellbeing, and applicable regulatory requirements. Since FY 2023-24, the Company has covered 72.4% of its suppliers, by value, under these awareness programmes. In FY 2025-26, 32.5% of suppliers, by value, were covered under awareness programmes across all principles. Details of the training programmes conducted are provided below.</Typography>
                        <TableContainer component={Paper} m>
                            <Table sx={{ minWidth: 650 }} size="small">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center" ><strong>Total number of training and awareness programmes held</strong></TableCell>
                                        <TableCell align="left" ><strong>Topics/ principles covered under the training and its impact</strong></TableCell>
                                        <TableCell align="center" ><strong>%age of persons in value chain covered by the awareness programmes </strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center'>9<br />(42 Cumulatively from FY 2023-24)</TableCell>
                                        <TableCell>
                                            <ol type='a' style={{ paddingLeft: 16 }}>
                                                <li>Essentials of Sustainability</li>
                                                <li>Regulatory requirements of Environment, Social, Governance, health, safety, &amp; working conditions.</li>
                                                <li>Various disclosures including BRSR &amp; other Reporting frameworks.</li>
                                                <li>M&amp;M’s ESG commitments</li>
                                                <li>Renewable Energy Workshop</li>
                                            </ol>
                                        </TableCell>
                                        <TableCell align='center'>
                                            32.5% in FY 2025-26<br />
                                            72.4% Cumulatively from FY 2023-24
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center'>6<br />(17 Cumulatively from FY 2020-21)</TableCell>
                                        <TableCell>
                                            <ol type='a' style={{ paddingLeft: 16 }}>
                                                <li>Basics of industrial Safety</li>
                                                <li>Safety risk mitigation techniques</li>
                                                <li>Occupational Health &amp; safety</li>
                                                <li>Personal Protective Equipment</li>
                                                <li>Regulatory requirements of health &amp; safety</li>
                                                <li>Electrical fire safety</li>
                                            </ol>
                                        </TableCell>
                                        <TableCell align='center'>
                                            11% in FY 2025-26<br />
                                            22.4% Cumulatively from FY 2020-21
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" align='center'>6<br />(10 Cumulatively from FY 2023-24)</TableCell>
                                        <TableCell>
                                            ESG, Ethics, Transparency, accountability, Supplier Risk Management, Value analysis &amp; Value Engineering, Program management, leadership, Strategy crafting and exhibition
                                        </TableCell>
                                        <TableCell align='center'>
                                            1.5% in FY 2025-26<br />
                                            13.1% Cumulatively from FY 2023-24
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} mb={5} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            2. Does the entity have processes in place to avoid/ manage conflict of interests involving members of the Board? (Yes/ No) If Yes, provide details of the same.
                            <ExpandMore
                                expand={expanded9}
                                onClick={handleExpandClick9}
                                aria-expanded={expanded9}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded9} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            Yes, the Company has laid out a separate Code of Conduct for the Board of Directors which sets clear guidelines for avoiding and disclosing actual or potential conflicts of interest with the Company. Directors are required to avoid any actual or perceived conflicts of interest that could impair their ability to perform their duties objectively and effectively. While Directors may engage in personal investments and maintain normal social or business interactions, they must not have interests that could negatively influence their responsibilities as members of the Board. The Code of Conduct outlines these expectations and provides guidance, although it does not cover every possible scenario. Any suspected or potential conflict must be disclosed promptly to the Chairman of the Board, who will assess the situation and decide on the appropriate action. Directors are expected to recuse themselves from discussions or decisions where a conflict exists or may appear to exist. Further, the Company also receives disclosure of interest at regular intervals from the directors.<br />
                            Name of the Policy: Code of Conduct for Directors<br />
                            Web-Link:<br />
                            <a href="https://www.mahindra.com/investor-relations/policies-and-documents" target="_blank" rel="noopener noreferrer">https://www.mahindra.com/investor-relations/policies-and-documents
                            </a>
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
        </Container>
    )
}


export default Sectionc1;